import { SET_ADMIN_USER } from "../actions/adminUserAction";

const defaultState = {
    SET_ADMIN_USER: null
}

export const adminUserReducer = (state = defaultState, action: any): any => {
    const { type, data } = action;

    if (type === SET_ADMIN_USER) return data;
    return state;
}